export default __webpack_public_path__ + "static/media/lock.8f8e4e7b.svg";